import IconComponent from "@CubeComponents/icons";
import { getNoAccessPage } from "@Features/estimation";
import { errorCodes } from "@Helpers/errorCodes";

const IssueErrorIllustration = ({ errorCode }: { errorCode: number }) => {
  return (
    <div className="w-full h-full flex items-center justify-center overflow-auto">
      {errorCode == errorCodes.ISSUE_NO_ACCESS ? (
        getNoAccessPage("Issue")
      ) : (
        <IconComponent name="404Illustration" width="22.5625rem" height="19rem" />
      )}
    </div>
  );
};

export default IssueErrorIllustration;
